import { Component, EventEmitter, Input, OnInit, SimpleChanges } from "@angular/core";
import { TreeNode } from "primeng/api";
import { AccountService } from "../service/account.service";

@Component({
    selector: "modal-show-report-accounts",
    templateUrl: "./modal-show-report-accounts.component.html",
})
export class ModalShowReportAccounts implements OnInit {
    constructor(private accountService: AccountService) {

        this.tableColumns = [
            { field: "name", header: "Name", width: "70%" },
            { field: "lineNumbers", header: "Row #", width: "30%"}
            
        ];


    }

    @Input() reportId: number;
    @Input() filter: string = null;

    @Input() buttonIcon: string = null;
    @Input() buttonText: string = null;

    @Input() displayAsTableOnly: boolean = false;
    @Input() selectionMode: string = "single";
    @Input() selected: TreeNode[];
  
    
    displayTable: boolean = false;
    accountsForTableExist: boolean;
    accountsForTable: TreeNode[];
    tableColumns: any[];
    loading: boolean = false;
    modalText: string;
    error: string = null;

    ngOnInit() {

        
    }

    openModal() {
        this.displayTable = true;
        this.loading = true;
        if (!this.buttonIcon && !this.buttonText) {
            this.displayTable = true;
        }
        if (this.filter == "all") {
            this.modalText = "All Accounts";
            this.accountService
                .getAll(this.reportId.toString(), [])
                .then((accounts) => this.loadAccounts(accounts));
        } else if (this.filter == "excluded") {
            this.modalText = "Excluded Accounts";
            this.tableColumns = [
                { field: "name", header: "Name", width: "100%" }
            ];
            this.accountService
                .getExcluded(this.reportId.toString(), [])
                .then((accounts) => this.loadAccounts(accounts));
        } else if (this.filter == "included") {
            this.modalText = "Included Accounts";
             this.selectionMode="single"
            this.accountService
                .getIncludedTree(this.reportId.toString(), [])
                .then((accounts) => this.loadAccounts(accounts));

        } else {
            this.buttonText = "Error";
            this.modalText = "Error";
            this.error = "Error has occured: no filter was specified.";
            this.loading = false;
        }
    }

    loadAccounts(accounts: TreeNode[]) {
        
        this.accountsForTable = accounts;
        console.log("this.accountsForTable")
        console.log(this.accountsForTable)
        this.accountsForTableExist =
            this.accountsForTable && this.accountsForTable.length > 0
                ? true
                : false;
        this.loading = false;
    }

    goToReportLine(id: number): void {
        console.log("tu sam")
        const url = `http://www.localhost:112/ReportLine/${id}`;
        window.open(url, '_blank');  // Open in a new tab
    }
    closeModalF(){
        //this.displayTable=false;
        console.log("closeModalF")
    }
}
